module.exports = __webpack_public_path__ + "img/arcos-c-img-4.1a989211.jpg";